import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import CloseIcon from '@mui/icons-material/Close';

export const TITLE_BAR_ACTIONS = (onUnhideAll, onClose) => [
    { icon: <DeleteSweepIcon sx={{ fontSize: 16 }} />, title: 'Unhide All', onClick: onUnhideAll },
    { icon: <CloseIcon sx={{ fontSize: 16 }} />, title: 'Close', onClick: onClose },
];
